<div
  data-tms-event="popup-impression"
  data-tms-popup-zone="cyber care"
  data-tms-popup-name="cease confirmation "
  attr.data-tms-product="{{ jsonProduct }}"
>
  <div class="rs-modal-close">
    <button
      class="rs-link-action rs-link-action-close close-reveal-modal"
      data-tms-button-name="close"
      data-tms-action-name="close"
      data-cy="cybercareCeaseModalCrossButton"
    >
      <span class="rs-action-link-icon" [title]="'common.overlayer.close.caption' | translate"
        ><span class="show-for-sr">{{ 'common.overlayer.close.caption' | translate }}</span></span
      >
    </button>
  </div>
  <div class="rs-modal-heading">
    <h2
      class="rs-modal-heading-title rs-has-subtit"
      id="modalCease_label"
      data-cy="cybercareCeaseModalTitle"
    >
      {{ 'cybercare.cease.popup.title' | translate }}
    </h2>
    <h3 class="rs-modal-heading-subtit" data-cy="cybercareCeaseModalSubtitle">
      {{ 'cybercare.cease.popup.subtitle' | translate }}
    </h3>
  </div>
  <div class="rs-modal-content" data-cy="cybercareCeaseModalDescription">
    <p>{{ 'cybercare.cease.popup.description' | translate }}</p>
  </div>
  <div class="rs-modal-footer">
    <div
      class="rs-flex-row rs-flex-middle-medium rs-justify-right-medium rs-flex-dir-col-small-only"
    >
      <div class="rs-flex-columns rs-flex-shrink rs-order-m2">
        <a
          href="{{ 'cybercare.cease.popup.button.continue.link' | translate }}"
          class="rs-btn rs-btn-nl-so"
          data-tms-button-name="confirm"
          data-tms-action-name="cease confirm"
          data-cy="cybercareCeaseModalContinueButton"
          >{{ 'cybercare.cease.popup.button.continue' | translate }}
        </a>
      </div>
      <div class="rs-flex-columns rs-order-m1">
        <a
          href="javascript:void(0)"
          class="rs-btn rs-btn-second rs-btn-nl-m close-reveal-modal"
          data-tms-button-name="back"
          data-tms-action-name="close"
          data-cy="cybercareCeaseModalBackButton"
          >{{ 'cybercare.cease.popup.button.back' | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
